export default __webpack_public_path__ + "static/media/support-allied-martin-ticinece.7b0cc3e8.png";